export default __webpack_public_path__ + "static/media/claro-music.53a7ca8b.svg";